import React from "react";
import { Link } from "react-router-dom";
import Strawberry from "../images/cards-images/Strawberry.png";
import Mango from "../images/cards-images/Mango.png";
import Potato from "../images/cards-images/Potato.png";
import Apple from "../images/cards-images/Apple.png";
import Cherry from "../images/cards-images/Cherry.png";
import Corn from "../images/cards-images/Corn.png";
import Grape from "../images/cards-images/Grape.png";
import Tomato from "../images/cards-images/Tomato.png";

export const DiseaseDetectionCards = () => {
  return (
    <div id="content">
      <div id="plant_disease" className="menu-content">
        <div className="cards-container">
          <div className="card">
            <img src={Strawberry} alt="Strawberry" />
            <h5 className="card-title">Strawberry</h5>
            <h5 className="card-title">اسٹرابیری</h5>
            <Link
              to="/strawberry"
              className="card-button"
              data-target="Strawberry"
            >
              Select
            </Link>
          </div>
          <div className="card">
            <img src={Mango} alt="Mango" />
            <h5 className="card-title">Mango</h5>
            <h5 className="card-title">آم</h5>
            <Link to="/mango" className="card-button" data-target="Mango">
              Select
            </Link>
          </div>
          <div className="card">
            <img src={Potato} alt="Potato" />
            <h5 className="card-title">Potato</h5>
            <h5 className="card-title">آلو</h5>
            <Link to="/potato" className="card-button" data-target="Potato">
              Select
            </Link>
          </div>
          <div className="card">
            <img src={Apple} alt="Apple" />
            <h5 className="card-title">Apple</h5>
            <h5 className="card-title">سیب</h5>
            <Link to="/apple" className="card-button" data-target="Apple">
              Select
            </Link>
          </div>
        </div>

        <div className="cards-container">
          <div className="card">
            <img src={Cherry} alt="Cherry" />
            <h5 className="card-title">Cherry</h5>
            <h5 className="card-title">چیری</h5>
            <Link to="/cherry" className="card-button" data-target="Cherry">
              Select
            </Link>
          </div>
          <div className="card">
            <img src={Corn} alt="Corn" />
            <h5 className="card-title">Corn</h5>
            <h5 className="card-title">مکئی</h5>
            <Link to="/corn" className="card-button" data-target="Corn">
              Select
            </Link>
          </div>
          <div className="card">
            <img src={Grape} alt="Grape" />
            <h5 className="card-title">Grape</h5>
            <h5 className="card-title">انگور</h5>
            <Link to="/grape" className="card-button" data-target="Grape">
              Select
            </Link>
          </div>
          <div className="card">
            <img src={Tomato} alt="Tomato" />
            <h5 className="card-title">Tomato</h5>
            <h5 className="card-title">ٹماٹر</h5>
            <Link to="/tomato" className="card-button" data-target="Tomato">
              Select
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
